import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-600f917a")

_pushScopeId("data-v-600f917a")
const _hoisted_1 = { class: "grid sm:grid-row-2 sm:grid-flow-col " }
const _hoisted_2 = { class: "mx-4 text-center mb-2 sm:mb-0 sm:text-left" }
const _hoisted_3 = { class: "text-gray-300 dark:text-gray-500 text-center sm:text-right" }
const _hoisted_4 = { class: "list" }
const _hoisted_5 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DefaultIcon = _resolveComponent("DefaultIcon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("icons.InputField.RatingTitle")), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("ul", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.maxStars, (star) => {
          return (_openBlock(), _createBlock("li", {
            key: star,
            class: [{ 'active': star <= _ctx.stars }, "star"],
            onClick: ($event: any) => (_ctx.rate(star))
          }, [
            _createVNode(_component_DefaultIcon, {
              icon: star <= _ctx.stars ? 'ratingfull_icon' : 'rating_icon'
            }, null, 8, ["icon"])
          ], 10, ["onClick"]))
        }), 128))
      ]),
      (_ctx.hasCounter)
        ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.stars) + " of " + _toDisplayString(_ctx.maxStars), 1))
        : _createCommentVNode("", true)
    ])
  ]))
})